import { useTranslation } from 'react-i18next';

export function OrderStatusTitle(props) {
  const { address, isExpense, vendorDetails } = props;
  const { t } = useTranslation();
  if (!isExpense && address != null) {
    return (
      <h3 className="order-status-title">
        {t('payments.payment_for')} {t(`payments.${address.translationKey}`, address)}
      </h3>
    );
  }
  if (isExpense && vendorDetails != null) {
    return (
      <h3 className="order-status-title">
        {t('payments.payment_for')} {vendorDetails.title}
      </h3>
    );
  }
  return null;
}
